import { Classify2LineIcon, Empty } from 'ui';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: break circular dependency
import { EntityList } from 'features/channels/components';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { useCommunitiesInfiniteQuery } from 'features/communities/queries';

type P = {
  getPathToCommunityDetail: (id: string) => string;
  organizationId: string;
};

const OrganizationsCommunitiesList = ({ getPathToCommunityDetail, organizationId }: P) => {
  const {
    data: allCommunitiesData,
    fetchNextPage,
    hasNextPage,
    isFetching: isFetchingAll,
    isLoading: isLoadingAll,
  } = useCommunitiesInfiniteQuery({
    filter: { organizationId },
    pagination: { pageSize: 12 },
  });

  const allCommunities = allCommunitiesData?.pages.flat().flatMap((communitiesPaginated) => communitiesPaginated.data);

  return (
    <EntityList
      empty={
        <Empty
          description={{
            subtitle: 'There are no communities to display here',
            title: 'No communities',
          }}
          image={<Classify2LineIcon />}
        />
      }
      entities={allCommunities?.map((community) => ({
        data: community,
        type: 'Community',
      }))}
      fetchNextPage={fetchNextPage}
      getPathToEntityDetail={getPathToCommunityDetail}
      hasNextPage={hasNextPage}
      isFetching={isFetchingAll}
      isLoading={isLoadingAll}
    />
  );
};

export default OrganizationsCommunitiesList;
